export const getPaystackMode = (
    configuredMode = process.env.REACT_APP_PAYSTACK_MODE
) => {
    if (configuredMode === "live" || configuredMode === "test") {
        return configuredMode;
    }

    throw new Error("REACT_APP_PAYSTACK_MODE must be either live or test");
};

const getPlanCode = (testCode, liveCode, mode = getPaystackMode()) => {
    const planCode = mode === "live" ? liveCode : testCode;

    if (!planCode) {
        throw new Error(`Missing ${mode} Paystack plan code`);
    }

    return planCode;
};

export default getPlanCode;
